// Copyright (c) 2021 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../actions-list';
import {getAllRequestAsPerStatus} from '../../shared/repositories';
import {initializeList} from './mass-labor-rate-request-filtered';

export const readAllRequestAsPerStatus = (requestStatus, searchFilters) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const getForTcsm = false;

        try {

            const allRequestDataAsperStatus = await getAllRequestAsPerStatus(requestStatus, getForTcsm);

            dispatch({
                data: allRequestDataAsperStatus,
                type: actions.SET_LABOR_RATE_REQUESTS_DETAILS
            });

            dispatch(initializeList(allRequestDataAsperStatus, searchFilters));

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-request-status-details/action-creators/read-all-request-as-per-status.js